import { FuseResult } from 'fuse.js';

export function mapObjectValues<T, K>(object: { [key: string]: T }, valueMapper: (key: string, value: any, index: number) => K): { [key: string]: K } {
  return Object.entries(object).reduce(
    (acc, [key, value], index) => ({
      ...acc,
      [key]: valueMapper(key, value, index),
    }),
    {},
  );
}

export function convertStringArrayToObject<K>(array: string[], valueFactory: (key: string, index: number) => K): { [key: string]: K } {
  return array.reduce((acc, key: string, index: number) => {
    return {
      ...acc,
      [key]: valueFactory(key, index),
    };
  }, {});
}

export function getFuseResults<T>(fuseResults: FuseResult<T>[]) {
  if (!fuseResults) {
    return [];
  }
  return fuseResults.map((result) => result.item);
}

export const getSubarrayOfResults = (results: any[], numberOfVisibleResults: number): any[] => {
  return results.length > numberOfVisibleResults ? results.slice(0, numberOfVisibleResults) : results;
};
